import { Button, Table } from '@loadsmart/loadsmart-ui'
import Icon from 'atoms/Icon'
import { Link } from 'react-router-dom'
import Pill from 'atoms/Pill'
import clsx from 'clsx'
import { IntegrationTemplate } from 'common/types/kraken-core/IntegrationTemplate'
import { useContext } from 'react'
import Loading from 'atoms/Loading'
import { IntegrationOnboardingContext } from '../IntegrationOnboardingContext'

export interface IntegrationTemplateListProps {
  templates: Array<IntegrationTemplate>
  // eslint-disable-next-line no-unused-vars
  onSelect: (template: IntegrationTemplate) => void
}

const COLUMNS = [
  {
    Header: 'Key',
    Cell(row: IntegrationTemplate) {
      return (
        <>
          {String(row.key)
            .split(':')
            .map(r => (
              <Pill key={`${r}`} className="ml-4 h-6">
                {r.toUpperCase()}
              </Pill>
            ))}
        </>
      )
    },
  },
  {
    Header: 'Actions',
    alignment: 'right',
    Cell(row: IntegrationTemplate) {
      const startOnboardButton = () => <Icon name="bolt" size={20} />

      const builderButton = () => <Icon name="edit" size={20} />

      return (
        <div className="flex justify-end">
          <div className="p-2">
            <Link to={`/integration/onboarding/template/${row.id}/onboard`}>
              <Button variant="primary" trailing={startOnboardButton()}>
                Onboard
              </Button>
            </Link>
          </div>
          <div className="p-2">
            <Link to={`/integration/onboarding/template/${row.id}/builder`}>
              <Button variant="secondary" trailing={builderButton()}>
                Builder
              </Button>
            </Link>
          </div>
        </div>
      )
    },
  },
]

function IntegrationTemplateList({ templates }: IntegrationTemplateListProps) {
  const context = useContext(IntegrationOnboardingContext)

  return (
    <div className="flex flex-col mt-4 self-start w-full">
      <div className="flex font-bold mt-4">Available templates:</div>
      {context?.isLoading && <Loading />}
      {!context?.isLoading && (
        <div className="flex">
          <Table scale="small" className="w-full" data-testid="message-list">
            <Table.Head>
              {COLUMNS.map(column => (
                <Table.Cell key={column.Header} alignment={column.alignment as any}>
                  {column.Header}
                </Table.Cell>
              ))}
            </Table.Head>
            <Table.Body>
              {templates &&
                templates.map((row: IntegrationTemplate) => (
                  <Table.Row key={row.id}>
                    {COLUMNS.map(cell => (
                      <Table.Cell
                        className={clsx('text-sm')}
                        key={`${row?.id}-${cell.Header}`}
                        alignment={cell.alignment as any}
                      >
                        {cell.Cell(row)}
                      </Table.Cell>
                    ))}
                  </Table.Row>
                ))}
            </Table.Body>
          </Table>
        </div>
      )}
    </div>
  )
}

export default IntegrationTemplateList
